'use client'
import { FC } from 'react'

import { Colour, SectionPaddingDefault } from '../constants'
import { Panel, PanelLayout } from '../Panel'
import cx from 'classnames'
import styles from './styles.module.scss'

import Marquee from 'react-fast-marquee'

import { CmsResponsiveImage, ImageFit } from '../Sections/PageHero'
import { HeroCtas } from '../Sections/PageHero/HeroCtas'
import { CmsPageSectionBase } from '../ComposedPage'
import { DynamicImage } from '../DynamicImage'

export interface CmsTickerTapeSection extends CmsPageSectionBase {
  fields: CmsPageSectionBase['fields'] & {
    backgroundColour: Colour
    tickerItems: string
    showOpenAccountButton: boolean
    openAccountButtonText?: string
    primaryCtaUrl?: string
    primaryCtaText?: string
    secondaryCtaUrl?: string
    secondaryCtaText?: string
    dividerStyle: Colour
    backgroundImage?: CmsResponsiveImage
  }
}

export const TickerTapeSection: FC<CmsTickerTapeSection> = ({ fields }) => {
  const {
    sectionPaddingTop,
    sectionPaddingBottom,
    backgroundColour,
    tickerItems,
    dividerStyle,
    backgroundImage,
    ...ctaProps
  } = fields

  const isBullet = dividerStyle === Colour.softBlack

  const Items: FC<{ isMobile?: boolean }> = ({ isMobile }) => {
    return (
      <div className={styles.item}>
        {tickerItems.split(';').map(item => {
          return (
            <span key={item}>
              {item}
              {isBullet && !isMobile && (
                <span className={styles.bullet}>&#x2022;</span>
              )}
              {(!isBullet || isMobile) && (
                <span className={styles.fullStop}>.</span>
              )}
            </span>
          )
        })}
      </div>
    )
  }

  return (
    <Panel
      className={styles.tickerTapeSection}
      colour={Colour[backgroundColour]}
      layout={PanelLayout.full}
      short
    >
      <div
        className={cx(
          styles.content,
          styles[sectionPaddingTop || SectionPaddingDefault.TOP],
          styles[sectionPaddingBottom || SectionPaddingDefault.BOTTOM],
        )}
      >
        <div className={styles.desktopTicker}>
          <Marquee autoFill>
            <Items />
          </Marquee>
        </div>
        <div className={styles.mobileStack}>
          <Items isMobile />
        </div>
        <HeroCtas className={styles.ctas} {...ctaProps} />
      </div>

      {backgroundImage && (
        <div className={styles.backgroundImage}>
          <DynamicImage
            image={backgroundImage}
            style={{ objectFit: ImageFit.COVER }}
            fill
          />
        </div>
      )}
    </Panel>
  )
}
